<template>
  <div class="d-flex" id="wrapper">
    <UserNavigationSidebar v-if="userType('candidate')" />
    <Sidebar v-if="userType('admin')" />
    <!-- Page Content -->
    <div id="page-content-wrapper">
      <TopNavbar :profile="getUserProfile" />

      <Message class="mt-4" type="warning-alert" v-if="alertMessage">
        <p slot="alert-message" class="mb-0">{{ alertMessage }}</p>
      </Message>

      <AdminSettings />
    </div>
  </div>
</template>

<script>
import TopNavbar from '@/components/Navigations/TopNavbar';
import UserNavigationSidebar from '@/components/Navigations/UserNavigationSidebar';
import Sidebar from '@/components/Navigations/Sidebar';
import AdminSettings from '@/components/Admin/Settings/AdminSettings';
import Message from '@/components/AlertMessages/Message';
import { required, minLength } from 'vuelidate/lib/validators';

import { userRoleMixin } from '../../mixins/userRoleMixin';

import { mapActions, mapGetters } from 'vuex';
import moment from 'moment-timezone';

export default {
  components: {
    Sidebar,
    Message,
    TopNavbar,
    AdminSettings,
    UserNavigationSidebar,
  },
  validations: {
    form: {
      oldPassword: {
        required,
        minLength: minLength(6),
      },
      newPassword1: {
        required,
        minLength: minLength(6),
      },
      newPassword2: {
        required,
        minLength: minLength(6),
      },
    },
  },
  mixins: [userRoleMixin],
  data: () => ({
    timeZones: [],
    timezone: 'Europe/Sofia (GMT+03:00) ',
    settings: {
      emailNotification: false,
      dateFormat: 'YY-MM-DD',
    },
    emailIntegration: {
      isEmailConnected: false,
      email: '',
      password: '',
    },
    alertMessage: '',
    form: {
      oldPassword: '',
      newPassword1: '',
      newPassword2: '',
    },
  }),
  methods: {
    ...mapActions(['connectEmail', 'retrieveUserProfile']),
    setSelectorOptions() {
      const selectorOptions = moment.tz
        .names()
        .reduce((memo, tz) => {
          memo.push({
            name: tz,
            offset: moment.tz(tz).utcOffset(),
          });

          return memo;
        }, [])
        .sort((a, b) => {
          return a.offset - b.offset;
        })
        .reduce((memo, tz) => {
          const timezone = tz.offset ? moment.tz(tz.name).format('Z') : '';

          return memo.concat(`${tz.name} (GMT${timezone})`);
        }, []);

      this.timeZones = selectorOptions;
    },
    setDefaultTimeZone() {
      moment.tz.setDefault(this.timezone);
    },
    connectToEmail() {
      this.connectEmail({
        email: this.emailIntegration.email,
        password: this.emailIntegration.password,
      }).then((response) => {
        console.log('res: ', response);
        if (response.status == 422) {
          this.$toasted.error('Wrong email/password!', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        } else {
          this.emailIntegration.isEmailConnected = true;
          this.$toasted.success('Email connected!', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      getAccType: 'getAccType',
      getUserProfile: 'getUserProfile',
    }),
  },
  mounted() {
    this.setSelectorOptions();
    // this.retrieveUserProfile();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables';

.col-sm-8 {
  position: relative;

  .fa-plug {
    position: absolute;
    font-size: 1rem;
    top: 10px;
    right: 22px;
  }
}

.connected {
  color: $color-status-active;
}
.disconnected {
  color: $color-status-closed;
}

.disconnected {
  color: $color-status-closed;
}

.settings {
  font-family: $font-family-sans-lato;
  padding-bottom: 30px;
  padding-left: 15px;
  padding-right: 15px;

  h3 {
    font-size: 18px;
    font-weight: 700;
    border-bottom: 1px solid #ddd;
    margin: 30px 0 12px 0;
    padding-bottom: 12px;
  }
  h5 {
    font-size: 2rem;
    font-family: $font-family-sans-serif;
    margin-bottom: 22px;
  }

  .form-group {
    font-family: $font-family-sans-lato;

    .col-form-label {
      font-size: 14px;
      font-weight: 700;
    }
  }
  /* .d-flex {
    .btn:first-of-type {
      background: $color-base-blue;
      border: none;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    .btn:nth-of-type(2) {
      background: $color-orange;
      border: none;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  } */
  /*  .btn-success {
    background: $color-base-blue;
    border-color: $color-base-blue;
  } */
}
.modal-body {
  font-size: 14px;
  padding: 20px 12px;
}
</style>
